import dayjs from "dayjs";

// Move the interfaces and default values here from FiltersSidebar.tsx

export interface ImageFilter {
  checked: boolean;
  imageCount: number;
  operator: string;
}

export interface AssetFilters {
  asset_id?: string;
  start_date?: string;
  end_date?: string;
  croppedImages: ImageFilter;
  configuration?: string;
  bgrImages: ImageFilter;
  exteriorImages: ImageFilter;
  featuredImages: ImageFilter;
  manualImages: ImageFilter;
  panoramicImages: ImageFilter;
  ucImages: ImageFilter;
  pushed?: boolean | null;
  syndicated?: boolean | null;
  processingStatus: string;
  syndicationStatus: string;
  archived: boolean;
}

export const defaultImageFilterValue: ImageFilter = {
  checked: false,
  imageCount: 0,
  operator: '=',
};

export const defaultFilters: AssetFilters = {
  asset_id: undefined,
  start_date: dayjs().subtract(7, "day").format("YYYY-MM-DD"),
  end_date: dayjs().format("YYYY-MM-DD"),
  croppedImages: defaultImageFilterValue,
  configuration: undefined,
  bgrImages: defaultImageFilterValue,
  exteriorImages: defaultImageFilterValue,
  featuredImages: defaultImageFilterValue,
  manualImages: defaultImageFilterValue,
  panoramicImages: defaultImageFilterValue,
  ucImages: defaultImageFilterValue,
  pushed: null,
  syndicated: null,
  processingStatus: "any",
  syndicationStatus: "any",
  archived: false,
};
